import { useContext } from 'react';

import { BP42Ctx, BP42CtxDispatch } from '@r1-frontend/bp42/BP42Context';
import { BP42Actions } from '@r1-frontend/bp42/reducer';

const useCtxDispatch = (): BP42CtxDispatch => {
    const { dispatch, debugMode } = useContext(BP42Ctx);

    return (action: BP42Actions) => {
        debugMode && console.log(action);
        dispatch(action);
    };
};

export default useCtxDispatch;
